const INITIAL_STATE = {
  data: {},
  errors: {},
}
	
const calculatePriceForPrepay = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'CALCULATE_PREPAY_PRICE_SUCCESSFULY':
	  return { ...state, ...INITIAL_STATE, data: action.data }
  case 'CALCULATE_PREPAY_PRICE_FAILED':
	  return { ...state, ...INITIAL_STATE, errors: action.data }
  default:
	  return { ...state }
  }
};
	
export default calculatePriceForPrepay;
	